import { useContext, useRef } from 'react'
import { Link } from 'react-router-dom'
import useOnScreen from '../../hooks/useOnScreen'
import { I18nContext } from '../../i18n'
import ArticleTitle from '../articleTitle/ArticleTitle'
import './Article.scss'

const Article = ({ className, to, title, img }) => {
  const { langCode } = useContext(I18nContext)
  const article = useRef(null)

  const isIntersecting = useOnScreen(article)

  return (
    <div ref={article} className={'article ' + className}>
      {isIntersecting && (
        <Link to={`/${langCode}/article/${to}`}>
          <img
            src={img}
            alt={title}
            width="391"
            height="220"
            className={'article__img '}
          />
          <ArticleTitle titleClass={'article__text'} text={title} size="12px" />
        </Link>
      )}
    </div>
  )
}

export default Article
